<template>
  <section class="container">
    <div class="row">
      <div class="col-6 offset-3 text-center d-flex mb-md-5">
        <h1 class="m-auto">
          Historique de vos sinistres
        </h1>
      </div>
      <div
        v-if="claims && claims.length > 0"
        class="col-3"
      >
        <router-link
          v-slot="{ navigate }"
          to="/client/claim/type"
          custom
        >
          <button
            type="button"
            class="d-flex btn btn-primary ms-auto fs-5 fw-bold"
            @click="navigate"
          >
            <div class="d-flex flex-row">
              <span class="d-md-inline d-none me-1">
                Déclarer
                <span class="d-none d-xxl-inline">
                  un sinistre
                </span>
              </span>
              <v-icon icon="plus-white" />
            </div>
          </button>
        </router-link>
      </div>
      <div
        v-for="(claimGroup, enumValue) in claimsByStatus"
        :key="enumValue"
        class="col-12"
      >
        <div class="fw-bold lead mb-2">
          {{ getStatusNameByEnumValue(enumValue) }}
        </div>
        <v-display
          v-for="claim in claimGroup"
          :key="claim.id"
          :claim="claim"
          :enum-value="enumValue"
          class="mb-2"
        />
      </div>
    </div>
    <v-no-resource v-if="claims && claims.length === 0">
      <div class="d-flex flex-column">
        <div class="lead">
          Vous n’avez encore déclaré aucun sinistre. Tant mieux !
        </div>
        <div class="mt-2">
          <router-link
            v-slot="{ navigate }"
            to="/client/claim/type"
            custom
          >
            <button
              type="button"
              class="btn btn-primary"
              @click="navigate"
            >
              <div class="d-flex flex-row">
                <div class="ms-auto me-1">
                  Déclarer un sinistre
                </div>
                <v-icon
                  icon="arrow-white-right"
                  class="me-auto"
                />
              </div>
            </button>
          </router-link>
        </div>
      </div>
    </v-no-resource>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';

import ClaimDisplay from './helpers/ClaimDisplay.vue';

export default {
  name: 'ClaimHome',
  components: {
    'v-display': ClaimDisplay,
  },
  computed: {
    ...mapGetters({
      claims: 'claim/claims',
    }),
    claimsByStatus() {
      return this.claims.reduce((acc, curr) => {
        if (acc[curr.status]) {
          acc[curr.status].push(curr);
        } else {
          acc[curr.status] = [curr];
        }
        return acc;
      }, {});
    },
  },
  beforeMount() {
    this.$store.dispatch('claim/getClaims');
  },
  methods: {
    getStatusNameByEnumValue(enumValue) {
      const status = {
        CREATED: 'Créé',
        IN_PROGRESS: 'En cours',
        CLOSED: 'Traité',
        DISMISSED: 'Sans suite',
        WAITING_FOR_PROOF: 'En attente de pièces',
        UNDER_REVIEW: 'A l\'étude',
        CHECKING: 'Vérification',
        HANDLED: 'Pris en charge',
        DECLINED: 'Refusé',
      };
      return status[enumValue];
    },
  },
};
</script>
